import React, { useState, useEffect } from 'react'
import { NoticeBar, Popup, Tag, Button } from 'react-vant'
import { Volume, Cross } from '@react-vant/icons'
import request from '../api/request'

export default function GlobalNoticeBar({ style, dark }) {
    const [notices, setNotices] = useState([])
    const [selectedNotice, setSelectedNotice] = useState(null)
    const [showDetail, setShowDetail] = useState(false)

    useEffect(() => {
        const fetchNotices = async () => {
            try {
                // 获取最新5条通知
                const res = await request.get('/v2/notifications/', {
                    params: { page: 1, page_size: 5 }
                })
                if (res.items && res.items.length > 0) {
                    setNotices(res.items)
                }
            } catch (err) {
                console.error('Failed to fetch notices:', err)
            }
        }
        fetchNotices()
    }, [])

    const displayNotices = notices.length > 0 ? notices : [
        {
            id: 0,
            title: '欢迎使用星翼智慧校园系统',
            content: '校园体质健康监测与赛事竞技数字化平台已全面上线运行，支持极速批量录入与成绩实时呈现。',
            created_at: new Date().toISOString()
        }
    ]

    // 将多条通知标题与内容预览拼接在一起循环滚动
    const fullText = displayNotices.map(n => {
        const preview = n.content ? `：${n.content}` : ''
        return `${n.title}${preview}`
    }).join('          📢          ')

    const handleClick = () => {
        setSelectedNotice(displayNotices[0])
        setShowDetail(true)
    }

    return (
        <>
            <div onClick={handleClick} style={{ cursor: 'pointer', ...style }}>
                <NoticeBar
                    style={{
                        borderRadius: 14,
                        boxShadow: dark ? 'none' : '0 2px 10px rgba(0,0,0,0.04)',
                        background: dark ? 'rgba(255,255,255,0.08)' : '#ffffff',
                        color: dark ? '#fff' : '#0f172a',
                        border: dark ? '1px solid rgba(255,255,255,0.1)' : '1px solid #e2e8f0',
                        fontSize: 13,
                        fontWeight: 500,
                        padding: '10px 14px',
                    }}
                    scrollable
                    leftIcon={<Volume color={dark ? '#34d399' : '#056b4f'} style={{ fontSize: 18, marginRight: 6 }} />}
                    text={fullText}
                />
            </div>

            {/* 通告详情弹窗 */}
            <Popup
                visible={showDetail}
                onClose={() => setShowDetail(false)}
                round
                position="bottom"
                style={{ padding: '24px 20px', maxHeight: '75%', borderRadius: '24px 24px 0 0' }}
            >
                {selectedNotice && (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Tag color="#056b4f" size="medium">系统公告</Tag>
                                <span style={{ fontSize: 12, color: '#94a3b8' }}>
                                    {selectedNotice.created_at ? new Date(selectedNotice.created_at).toLocaleString() : '最新'}
                                </span>
                            </div>
                            <div onClick={() => setShowDetail(false)} style={{ cursor: 'pointer', padding: 4 }}>
                                <Cross style={{ fontSize: 18, color: '#94a3b8' }} />
                            </div>
                        </div>

                        <h3 style={{ fontSize: 18, fontWeight: 800, color: '#0f172a', marginBottom: 12, lineHeight: 1.4 }}>
                            {selectedNotice.title}
                        </h3>

                        <div style={{
                            background: '#f8fafc',
                            borderRadius: 14,
                            padding: '16px',
                            fontSize: 14,
                            lineHeight: 1.6,
                            color: '#334155',
                            whiteSpace: 'pre-wrap',
                            marginBottom: 20
                        }}>
                            {selectedNotice.content || '暂无详细内容'}
                        </div>

                        {displayNotices.length > 1 && (
                            <div style={{ marginBottom: 20 }}>
                                <div style={{ fontSize: 13, fontWeight: 700, color: '#64748b', marginBottom: 8 }}>
                                    全部最新通知 ({displayNotices.length})
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                    {displayNotices.map(item => (
                                        <div
                                            key={item.id}
                                            onClick={() => setSelectedNotice(item)}
                                            style={{
                                                padding: '10px 12px',
                                                borderRadius: 10,
                                                background: selectedNotice.id === item.id ? '#f0fdf4' : '#f8fafc',
                                                border: selectedNotice.id === item.id ? '1px solid #a7f3d0' : '1px solid transparent',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <span style={{ fontSize: 13, fontWeight: 600, color: selectedNotice.id === item.id ? '#056b4f' : '#334155' }}>
                                                {item.title}
                                            </span>
                                            <span style={{ fontSize: 11, color: '#94a3b8' }}>›</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <Button
                            type="primary"
                            block
                            round
                            onClick={() => setShowDetail(false)}
                            style={{
                                background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
                                border: 'none',
                                fontWeight: 700
                            }}
                        >
                            我知道了
                        </Button>
                    </div>
                )}
            </Popup>
        </>
    )
}
